module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Avslutad":"Closed"},"sv":{"Avslutad":"Avslutad"}}')
  delete Component.options._Ctor
}
